export { Survey } from "../vue/survey.vue";
export { CustomWidget } from "../vue/customwidget.vue";
export { SurveyString } from "../vue/string.vue";
export { SurveyStringViewer } from "../vue/string-viewer.vue";
export { SurveyStringEditor } from "../vue/string-editor.vue";
export { SurveyElementVue } from "../vue/element.vue";
export { PopupSurvey, SurveyWindow } from "../vue/popup-survey.vue";
export { Page } from "../vue/page.vue";
export { Radiogroup } from "../vue/radiogroup.vue";
export { RadiogroupItem } from "../vue/radiogroupitem.vue";
export { OtherChoice } from "../vue/question-other.vue";
export { OtherComment } from "../vue/question-comment.vue";
export { Rating } from "../vue/rating.vue";
export { RatingDropdown } from "../vue/rating-dropdown.vue";
export { Comment } from "../vue/comment.vue";
export { Ranking } from "../vue/ranking/ranking.vue";
export { RankingItem } from "../vue/ranking/ranking-item.vue";
export { Checkbox } from "../vue/checkbox.vue";
export { CheckboxItem } from "../vue/checkboxitem.vue";
export { ButtonGroup } from "../vue/buttongroup.vue";
export { ButtonGroupItem } from "../vue/buttongroupitem.vue";
export { QuestionText } from "../vue/text.vue";
export { QuestionTextInput } from "../vue/text-input.vue";
export { Boolean } from "../vue/boolean";
export { BooleanSwitch } from "../vue/boolean-switch.vue";
export { BooleanCheckbox } from "../vue/boolean-checkbox.vue";
export { BooleanRadio } from "../vue/boolean-radio.vue";
export { BooleanRadioItem } from "../vue/boolean-radio-item.vue";
export { Empty } from "../vue/empty.vue";
export { MultipleText } from "../vue/multipletext.vue";
export { MultipleTextItem } from "../vue/multipletextitem.vue";
export { Matrix } from "../vue/matrix.vue";
export { Dropdown } from "../vue/dropdown.vue";
export { DropdownSelect } from "../vue/dropdown-select.vue";
export { Tagbox } from "../vue/tagbox.vue";
export { File } from "../vue/file.vue";
export { MatrixCell } from "../vue/matrixcell.vue";
export { MatrixHeaderRequired } from "../vue/matrixheaderrequired.vue";
export { MatrixTable } from "../vue/matrixtable.vue";
export { MatrixDropdown } from "../vue/matrixdropdown.vue";
export { MatrixDynamic } from "../vue/matrixdynamic.vue";
export { Errors } from "../vue/errors.vue";
export { Html } from "../vue/html.vue";
export { Expression } from "../vue/expression.vue";
export { ImagePicker } from "../vue/imagepicker.vue";
export { ImagePickerItem } from "../vue/imagepicker-item.vue";
export { PanelDynamic } from "../vue/paneldynamic.vue";
export { PanelDynamicProgress } from "../vue/paneldynamicprogress.vue";
export { PanelDynamicProgressV2 } from "../vue/paneldynamicprogressV2.vue";
export { Progress } from "../vue/progress.vue";
export { ProgressButtons } from "../vue/progressButtons.vue";
export { ProgressToc } from "../vue/progressToc.vue";
export { TimerPanel } from "../vue/timerpanel.vue";
export { Panel } from "../vue/panel.vue";
export { FlowPanel } from "../vue/flowpanel.vue";
export { FlowPanelElement } from "../vue/flowpanelelement.vue";
export { Row } from "../vue/row.vue";
export { ElementHeader } from "../vue/elementheader.vue";
export { QuestionImage } from "../vue/image.vue";
export { SignaturePad } from "../vue/signaturepad.vue";
export { SurveyHeader } from "../vue/header.vue";
export { Custom } from "../vue/custom.vue";
export { Composite } from "../vue/composite.vue";

export { TitleElement } from "../vue/components/title/title-element.vue";
export { TitleContent } from "../vue/components/title/title-content.vue";
export { TitleActions } from "../vue/components/title/title-actions.vue";
export { ActionBarViewModel } from "../vue/components/action-bar/action-bar.vue";
export { SvgIcon } from "../vue/components/svg-icon/svg-icon.vue";
export { PopupPointer } from "../vue/components/popup/popup-pointer.vue";
export { Popup } from "../vue/components/popup/popup.vue";
export { List } from "../vue/components/list/list.vue";
export { DropdownOptionItem } from "../vue/components/dropdown/option-item.vue";
export { DropdownComponent } from "../vue/components/dropdown/dropdown.vue";
export { TagboxFilterComponent } from "../vue/components/tagbox/tagbox-filter.vue";
export { TagboxComponent } from "../vue/components/tagbox/tagbox.vue";
export { TagboxItem } from "../vue/components/tagbox/tagbox-item.vue";
export { RatingItem } from "../vue/components/rating/rating-item.vue";
export { RatingItemStar } from "../vue/components/rating/rating-item-star.vue";
export { RatingItemSmiley } from "../vue/components/rating/rating-item-smiley.vue";
export { SurveyQuestionMatrixDynamicRemoveButton } from "../vue/components/matrix-actions/remove-button/remove-button.vue";
export { SurveyQuestionMatrixDetailButton } from "../vue/components/matrix-actions/detail-button/detail-button.vue";
export { SurveyQuestionMatrixDynamicDragDropIcon } from "../vue/components/matrix-actions/drag-drop-icon/drag-drop-icon.vue";
export { PanelDynamicAddBtn } from "../vue/components/paneldynamic-actions/paneldynamic-add-btn.vue";
export { PanelDynamicNextBtn } from "../vue/components/paneldynamic-actions/paneldynamic-next-btn.vue";
export { PanelDynamicPrevBtn } from "../vue/components/paneldynamic-actions/paneldynamic-prev-btn.vue";
export { PanelDynamicProgressText } from "../vue/components/paneldynamic-actions/paneldynamic-progress-text.vue";
export { PanelDynamicRemoveButton } from "../vue/components/paneldynamic-actions/paneldynamic-remove-btn.vue";

export { SurveyNavigationButton } from "../vue/components/survey-actions/survey-nav-button.vue";
export { Skeleton } from "../vue/components/skeleton.vue";
export { BrandInfo } from "../vue/components/brand-info.vue";
export { NotifierComponent } from "../vue/components/notifier.vue";
export { ComponentsContainer } from "../vue/components/container.vue";
export { CharacterCounterComponent } from "../vue/components/character-counter.vue";

import { SurveyModel } from "survey-core";

SurveyModel.platform = "vue";